'use es6';

import UISideNav from 'UIComponents/nav/UISideNav';
export default UISideNav;